import { createContext, useContext, useState, useCallback } from "react";
import LoginModal from "./LoginModal";

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState({});

  const open = useCallback((opts = {}) => {
    setOptions(opts);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setOptions({});
  }, []);

  return (
    <LoginModalContext.Provider value={{ open, close, isOpen }}>
      {children}
      <LoginModal
        open={isOpen}
        onClose={close}
        redirectTo={options.redirect}
        toastMessage={options.toast}
      />
    </LoginModalContext.Provider>
  );
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext);
  if (!ctx) {
    throw new Error("useLoginModal must be used within a LoginModalProvider");
  }
  return ctx;
}